require('jquery');
require('angular');
import angular from 'angular';
window.angular = angular;

require('bootstrap');
require('ag-grid-enterprise');
require('ng-cells/dist/latest/ng-cells.css');
require('ng-cells/dist/latest/ng-cells.js');
require('angular-ui-switch');
require('malihu-custom-scrollbar-plugin');
require('angularjs-toaster');
require('angular-aside');
require('v-accordion/dist/v-accordion.min.css');
require('angular-wizard');
require('ui-select');
require('ngGallery');
require('jquery-contextmenu');
require('leaflet');
require('leaflet-extra-markers');
require('leaflet.awesome-markers');
require('leaflet.markercluster');
require('bootstrap-slider');
require('angular-query-builder');
require('bg-splitter');
require('moment');
require('angular-google-plus');
require('zone.js');
require('select2');
require('sweetalert2');
require('apexcharts');
require('sprintf-js');

require('./extern/codemirror/codemirror');
require('./extern/contextMenu/contextMenu')


import jQuery from 'jquery';
window.jQuery = jQuery;

import CodeMirror from './extern/codemirror/codemirror';
window.CodeMirror = CodeMirror;

import swal from 'sweetalert2';
window.swal = swal;

require('signalr/jquery.signalR.js');

